import React, { useState } from 'react';
import { Getintouch } from '../Home/Getintouch';

function Omnichannel() {
  const featuresData = [
    {
      title: "Seamless betting across all channels",
      description:
        "Same or different odds for online and retail. A single account and wallet to connect channels. A unified back-office solution to manage product and players across all channels.",
    },
    {
      title: "Pure B2B and highly scalable solution",
      description:
        "Highly scalable platform offering an increase in coverage not matched by any other provider. Available for pre-live and live sports, in-house and 3rd party virtual games and lotteries.",
    },
    {
      title: "Leading user experience and technology",
      description:
        "Built on top of a cutting-edge tech stack, the front-end is compatible with tablets, lightweight mobile clients, as well as traditional SSBTs. Includes bonus campaigns, cash-out and bet builder features.",
    },
    {
      title: "Omnichannel acquisition and retention",
      description:
        "From detailed sports offer customization to sports-specific bonusing, OddsMatrix empowers you to focus on player acquisition and retention seamlessly across channels.",
    },
  ];
  const tabData = [
    {
      id: 'cashier',
      title: 'CASHIER',
      content: [
        'Multiple features to increase operational efficiency',
        'Book-a-bet, quick betting codes, print betting and lottery offers, and more',
        'Cash Register with real-time information',
        'Barcode-based membership card',
        'Numerous bonus possibilities',
        'Fully configurable betting tickets',
        'Cash management and reporting',
        'Multiple online and cash-based payment methods available',
        'Basic hardware configuration for cost efficiency',
      ],
      image: 'https://everymatrix.com/wp-content/uploads/2024/11/Frame-4813-1.png',
    },
    {
      id: 'self-service-betting-terminals-ssbt',
      title: 'SELF-SERVICE BETTING TERMINALS (SSBT)',
      content: [
        'Pre-live and live sports betting, virtual sports, and world lotteries',
        'Multi device fully responsive front-end, tailored for self-service devices',
        'Fully featured sportsbook platform',
        'Includes sportsbook bonus campaigns, Cash-out and Bet Builder features',
        'Anonymous to account-based betting with player identification options',
        'Easy upgrade of anonymous players to full online account holders',
        'Customizable high-quality terminals, ranging from low cost to high class models',
      ],
      image: 'https://everymatrix.com/wp-content/uploads/2024/11/retrail-cashier-1-3.png',
    },
    {
      id: 'retail-live-screens',
      title: 'RETAIL LIVE SCREENS',
      content: [
        'Display events, odds, and results for sports, virtual sports, and world lotteries',
        'Display promotional banners, websites, and videos',
        'Controlled through a dedicated module from the back-office',
        'Fully manage betting offer to be shown per screen and location',
        'Cost-effective setup based on standard TV, Android TV box, and Chrome browser',
      ],
      image: 'https://everymatrix.com/wp-content/uploads/2022/09/retrail-cashier-3.png',
    },
    {
      id: 'back-office',
      title: 'BACK-OFFICE',
      content: [
        'Supports both large scale betting operations and start-ups',
        'Fully managed sportsbook solution back-office',
        'Full retail network management section',
        'Product and location-based retail risk management',
        'Reports with detailed sportsbook specific KPIs',
        'Granular retail filters by channel, shop or terminal',
        'Module to support franchise retail operations',
      ],
      image: 'https://everymatrix.com/wp-content/uploads/2022/09/retrail-cashier-4.png',
    },
  ];
  const [activeTab, setActiveTab] = useState('cashier');

  const highlightsData = [
    {
      title: 'Bet on Sports',
      img: 'https://everymatrix.com/wp-content/uploads/2022/09/Sports.svg',
      alt: 'Bet on Sports',
      points: [
        'Available on all channels',
        'Competitive pre-live and live coverage, including market-specific events',
        'Massive selection of betting markets',
        'Bet builder across 11 sports',
        'Early, partial, and automated cash-out available for singles and multiples across all sports and markets',
        'Extensive language coverage'
      ]
    },
    {
      title: 'Bet on Virtuals',
      img: 'https://everymatrix.com/wp-content/uploads/2022/09/Virtual.svg',
      alt: 'Bet on Virtuals',
      points: [
        'Available on all channels',
        'Dedicated in-house virtual horse racing with certified RNG',
        'On demand additional virtual sports from 3rd Party providers',
        'Easy customization via the back-office',
        'Dedicated virtual screen for TVs in shop'
      ]
    },
    {
      title: 'Bet on Lotteries',
      img: 'https://everymatrix.com/wp-content/uploads/2022/09/Lottery.svg',
      alt: 'Bet on Lotteries',
      points: [
        'Available on all channels',
        'Fixed odds lottery betting product allowing players to place bets on numbers drawn in 100+ lotteries around the world',
        'Proprietary models for 20+ markets',
        'Frequent lottery draws (every 5 minutes)',
        'Dedicated lotto screen for TVs in shop'
      ]
    }
  ];
  return (
    <>
      <nav className="product-submenu blue_nav">
        <ul>
          <li>
            <a href="/fantasy-betting">Overview</a>
          </li>
          <li>
            <a href="/fantasy-betting/sportsbook">Sportsbook</a>
          </li>
          <li className='active'>
            <a href="/fantasy-betting/omnichannel/">Omnichannel</a>
          </li>
          <li>
            <a href="/fantasy-betting/esports-services/">Esports Services</a>
          </li>
          <li>
            <a href="/" target="_blank">Data Feeds</a>
          </li>
        </ul>
      </nav>
      <section className="">
        <div className="container container_custom">
          <div className="row g-md-5 g-4 justify-content-between align-items-center">
            <div className="col-md-5">
              <h1 className="section-title heading_left pt-5">One Sportsbook, <br />Unlimited Performance</h1>
              <div className="description"><p>A modular and agile sportsbook platform offering the best-in-industry sports and esports events coverage. OddsMatrix is built on a new tech stack that ensures high productivity, stability, and scalability.</p>
              </div>
              <div className="btns pt-5">
                <a href="/connect" className="btn btn_blue">Contact us</a>
              </div>
            </div>
            <div className="col-md-6">
              <img className='w-100' src="https://everymatrix.com/wp-content/uploads/2024/11/Hero-1.png" />
            </div>
          </div>
          <div className='simple-intro explore_bottom'>
            <a href="#explore" className="explore"></a>
          </div>
        </div>
      </section>

      <section className="features mt-5">
        <div className="container">
          <div className="row">
            {featuresData.map((item, index) => (
              <div className="col" key={index}>
                <div className="inner">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="services-tabs text-center sec-padd box-full">
        <div className="container">
          <div className="row">
            <div className="col-xl-10 mx-auto">

              <ul className="nav nav-tabs justify-content-center mb-4" id="retailTabs" role="tablist">
                {tabData.map((tab) => (
                  <li className="nav-item" key={tab.id} role="presentation">
                    <button
                      className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                      id={`${tab.id}-tab`}
                      data-bs-toggle="tab"
                      type="button"
                      role="tab"
                      onClick={() => setActiveTab(tab.id)}
                    >
                      {tab.title}
                    </button>
                  </li>
                ))}
              </ul>

              <div className=" tab-content">
                {tabData.map((tab) => (
                  <div
                    key={tab.id}
                    className={`tab-pane fade ${activeTab === tab.id ? 'show active' : ''}`}
                    id={tab.id}
                    role="tabpanel"
                    aria-labelledby={`${tab.id}-tab`}
                  >
                    <div className="row align-items-center text-start">
                      <div className="col-lg-6">
                        <div className='box'>
                          <div className='inner'>
                            <ul>
                              {tab.content.map((item, index) => (
                                <li key={index}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <img src={tab.image} alt={tab.title} className="img-fluid" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="highlights box-full bg-light sec-padd  mt-5 " id="highlights">
        <div className='container box'>
          <div className='row g-4'>
            <div className='col-md-12'>
              <h2 className="section-title text-center mb-5">Betting Offer Highlights</h2>
              <ul className="list-unstyled row justify-content-center g-4 pt-5 inner">
                {highlightsData.map((item, index) => (
                  <li key={index} className="list-item col-md-4">
                    <div className="inner text-center h-100 p-5 border rounded shadow-sm">
                      <div className="img-holder mb-3">
                        <img src={item.img} alt={item.alt} className="img-fluid" style={{ height: "150px" }} />
                      </div>
                      <h4 className="section-title my-5">{item.title}</h4>
                      <div className="circle-list text-start mt-3">
                        <ul>
                          {item.points.map((point, i) => (
                            <li key={i}>{point}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="bonusing box-full sec-padd">
        <div className="container">
          <div className="row">
            <div className="col box">
              <div className="inner">
                <div className="inner-content">
                  <div className="row d-flex align-items-center justify-content-between">
                    <div className="col-lg-5">
                      <h3 className="section-title text-left">Omnichannel Bonusing </h3>
                      <div className="description">
                        <p>Our clients are leveraging BonusEngine with the OddsMatrix Sportsbook to create rewarding omnichannel player journeys, extended player sessions, increased reactivation, stronger retention and reduced bonusing costs.</p>
                        <ul>
                          <li>Competitive live betting coverage, including market-specific events</li>
                          <li>Include or exclude channels ( mobile, web, retail)</li>
                          <li>Seamless integration of operators’ existing loyalty programs</li>
                          <li>Bonus examples: Free Bets, Cash Bonus, Multi-level Wagering bonuses with different rewards per level, fully automated Cash Back based on the player’s losses, Sports Tournaments, Odds Boost, Stake Back, Risk-free Bets and more.</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-6 ml-auto d-flex align-items-center">
                      <img src="https://everymatrix.com/wp-content/uploads/2024/11/bonus-2.png" alt="Omnichannel Bonusing " />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Getintouch/>

    </>
  )
}

export default Omnichannel